import axios from 'axios'
import { EnumResponse } from '@/api/services/common.dto'

class CaseValidationActionConfigurationService {
    async getCaseValidationActions(): Promise<EnumResponse[]> {
        const response = await axios.get(`/configuration/caseValidationActions`)
        return response.data
    }
}

export const caseValidationActionConfigurationService = new CaseValidationActionConfigurationService()
